(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/navbig/assets/javascripts/commands/nav-big-match-command.js') >= 0) return;  svs.modules.push('/components/statistics/navbig/assets/javascripts/commands/nav-big-match-command.js'); 
var svs = svs || {};

(function(svs, _) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.commands = svs.statistics.big.commands || {};

  svs.statistics.big.commands.NavBigMatchCommand = function() {
    var assetsLoader = false;

    var createModel = function(options, match) {
      var model = new svs.statistics.big.models.BigStatisticsModel({
        match: match,
        updateResult: true,
        showRegCloseTime: false,
        showBackButton: false,
        showPlayNow: true,
        updateOdds: true,
        showOdds: true,
        omitSwipeRefresh: true
      });

      return model;
    };

    var doCreateMatch = function(options, match) {

      if (
        _.isObject(options.model) &&
        options.model instanceof svs.statistics.models.Match
      ) {
        match = options.model.get('response');
      }

      if (
        _.isObject(options.model) &&
          options.model instanceof svs.statistics.models.Match ||
        !_.isObject(options.model) ||
        !(options.model instanceof svs.statistics.big.models.BigStatisticsModel)
      ) {
        options.model = createModel(options, match);
      }

      if (
        options.model &&
        options.model.get('draw') &&
        options.model.get('draw').drawNumber ===
          svs.statistics.constants.SPECIAL_TROTTING_DRAW
      ) {
        if (options.model.get('match') && options.model.get('match').sport) {
          options.model.get('match').sport.id =
            svs.statistics.constants.TROTTING;
          options.model.get('match').sport.type =
            svs.statistics.constants.TYPE_TROTTING;
        }
      }

      var bigStatView = new svs.statistics.big.views.BigStatisticsView({
        app: this.app || options.app,
        model: options.model,
        region: options.region,
        preDraw: false,
        skippAnim: options.skippAnim || false,
        selectedTab: options.selectedTab,
        usePageScroll: options.usePageScroll,
        path: Boolean(options.path)
      });

      return { view: bigStatView, model: options.model };
    };

    var loadMatch = function(options, cb, cbFunc, predraw) {
      options = _.extend(
        {
          matchId: '',
          bigNavRef: this
        },
        options
      );

      options.cb = cb;
      options.cbFunc = cbFunc;

      var match;

      var asyncReqList = [];
      if (predraw) {
        asyncReqList = [
          function loadAssets(callback) {
            if (assetsLoader) {
              callback();
            } else if (options.matchId) {
              svs.core.module.load(
                '/sportservice/match/{id}',
                null,
                callback,
                options.matchId
              );
            } else {
              callback();
            }
          }
        ];
      } else {
        asyncReqList = [
          function loadAssets(callback) {
            if (assetsLoader) {
              callback();
            } else if (options.matchId) {
              svs.core.module.load(
                '/sportservice/match/{id}',
                null,
                callback,
                options.matchId
              );
            } else {
              callback();
            }
          },

          function fetchMatch(callback) {
            if (_.isObject(options.model) && options.model.get('match')) {
              match = options.model.get('match');
              callback();
            } else if (options.matchId) {
              svs.core.jupiter.call(
                {
                  method: 'get',
                  path: '/sport/1/matches/' + options.matchId + '/matchlist'
                },
                function(response) {
                  match = response.match;
                  callback();
                }
              );
            } else {
              callback();
            }
          }
        ];
      }

      async.parallel(asyncReqList, onAssetsLoadedAndMatchFetched);
      function onAssetsLoadedAndMatchFetched() {
        assetsLoader = true;

        if (match && !options.model) {
          options.model = createModel(options, match);
        }

        options.cb[options.cbFunc](options, match);

        if (options.cbFunc === 'preDrawMatch') {
          options.cb.preDrawMatchLoaded(options);
        }
      }

      return assetsLoader;
    };

    return {
      doCreateMatch: doCreateMatch,
      loadMatch: loadMatch
    };
  };

  svs.statistics.big.commands.navBigMatchCommand = new svs.statistics.big.commands.NavBigMatchCommand();
})(svs, _);

 })(window);